import { render, staticRenderFns } from "./DowntimeReasonWizard.vue?vue&type=template&id=b64363f6&scoped=true"
import script from "./DowntimeReasonWizard.vue?vue&type=script&lang=js"
export * from "./DowntimeReasonWizard.vue?vue&type=script&lang=js"
import style0 from "./DowntimeReasonWizard.vue?vue&type=style&index=0&id=b64363f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64363f6",
  null
  
)

export default component.exports